// extracted by mini-css-extract-plugin
module.exports = {"month":"Todo_month__2wpz0","monthpadding":"Todo_monthpadding__FIIMX","trBackground":"Todo_trBackground__2An_y","trColor":"Todo_trColor__3Abs3","AddButton":"Todo_AddButton__3Y4jg"};